import {adminUrls} from "./admin";
import customerUrls from "./customer";

export const panelUrls = {
    admin: adminUrls,
    customer: customerUrls,
}